/**
 * TanStack Query hooks for `custom-partner-email-sender-domain-smtp-relay`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customPartnerEmailSenderDomainSmtpRelayQueryKeys,
	type CreateCustomPartnerEmailSenderDomainSmtpRelayBody,
	type ListCustomPartnerEmailSenderDomainSmtpRelayResponse,
	type CustomPartnerEmailSenderDomainSmtpRelayRow,
} from "./api";

export function useCustomPartnerEmailSenderDomainSmtpRelayList(): UseQueryResult<ListCustomPartnerEmailSenderDomainSmtpRelayResponse, Error> {
	return useQuery({
		queryKey: customPartnerEmailSenderDomainSmtpRelayQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomPartnerEmailSenderDomainSmtpRelayCreate(): UseMutationResult<CustomPartnerEmailSenderDomainSmtpRelayRow, Error, CreateCustomPartnerEmailSenderDomainSmtpRelayBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPartnerEmailSenderDomainSmtpRelayQueryKeys.all });
		},
	});
}

export function useCustomPartnerEmailSenderDomainSmtpRelayDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customPartnerEmailSenderDomainSmtpRelayQueryKeys.all });
		},
	});
}
